var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-5" },
    [
      _c("div", { staticClass: "flex bg-white" }, [
        _c(
          "div",
          { staticClass: "flex1" },
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "card" },
                on: { "tab-click": _vm.typeClick },
                model: {
                  value: _vm.listQuery.cate_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "cate_id", $$v)
                  },
                  expression: "listQuery.cate_id",
                },
              },
              _vm._l(_vm.tab, function (item, index) {
                return _c("el-tab-pane", {
                  key: index,
                  attrs: {
                    label: item.cate_name,
                    name: "" + item.cate_id + "",
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "scan-code_btn" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: {
                  click: function ($event) {
                    _vm.editForm = { cate_id: parseInt(_vm.listQuery.cate_id) }
                    _vm.editDialog = true
                  },
                },
              },
              [_vm._v("添加问题")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bg-white" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "list_table",
              attrs: {
                id: "list_table",
                stripe: "",
                "highlight-current-row": "",
                "element-loading-text": "Loading",
                data: _vm.list,
                "max-height": _vm.tableMaxH,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "类型", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.tabName[scope.row.cate_id] || "--") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "标题" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.title) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "描述" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "info-box fs-s4" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.content) +
                              "\n          "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              round: "",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                ;(_vm.editForm = JSON.parse(
                                  JSON.stringify(scope.row)
                                )),
                                  (_vm.editDialog = true)
                              },
                            },
                          },
                          [_vm._v("修改")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              round: "",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.del(scope.row, scope.$index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex justify-center" },
            [
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listQuery.page_num > 0,
                    expression: "listQuery.page_num > 0",
                  },
                ],
                attrs: {
                  page: _vm.listQuery.start,
                  limit: _vm.listQuery.limit,
                  "page-count": _vm.listQuery.page_num,
                  layout: "sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQuery, "start", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listQuery, "limit", $event)
                  },
                  pagination: _vm.getList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑问题",
            visible: _vm.editDialog,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "auto" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "类型：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.editForm.cate_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "cate_id", $$v)
                        },
                        expression: "editForm.cate_id",
                      },
                    },
                    _vm._l(_vm.tab, function (item, index) {
                      return _c("el-option", {
                        key: item.cate_id,
                        attrs: { label: item.cate_name, value: item.cate_id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "标题：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.editForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "title", $$v)
                      },
                      expression: "editForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "描述：" } },
                [
                  _c("el-input", {
                    attrs: {
                      autosize: { minRows: 3, maxRows: 6 },
                      type: "textarea",
                    },
                    model: {
                      value: _vm.editForm.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "content", $$v)
                      },
                      expression: "editForm.content",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }